import {inject, Injectable} from '@angular/core';
import {EventTypes, OidcSecurityService, PublicEventsService} from 'angular-auth-oidc-client';
import {Observable, of} from 'rxjs';

import {filter, switchMap} from "rxjs/operators";
import {checkAuthCallbackError, resetBrowserHistory} from "../../core/utils/check-auth-callback-error";

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private oidcSecurityService = inject(OidcSecurityService);
    private readonly eventService = inject(PublicEventsService);

    private events$ = this.eventService.registerForEvents();

    constructor() {
        this.events$
            .pipe(filter(
                (notification) =>
                    notification.type === EventTypes.TokenExpired
            ))
            .subscribe(()=>{
                resetBrowserHistory();
                window.location.replace('/logout.html');
            });
    }

    isAuthenticated() {
        return this.oidcSecurityService.isAuthenticated$;
    }

    getUser() {
        return this.oidcSecurityService.userData$;
    }

    login() {
        return this.oidcSecurityService.authorize();
    }

    logout() {
        return this.oidcSecurityService.logoff();
    }

    getAccessToken(): Observable<string> {
        return this.oidcSecurityService.getAccessToken();
    }

    checkAuth() {
        return this.oidcSecurityService.checkAuth()
            .pipe(switchMap(response=>
                of({response, callbackError: checkAuthCallbackError()} as CheckAuthResult )));
    }
}

export interface CheckAuthResult {
    response: {
        isAuthenticated: boolean;
        userData: any;
        accessToken: string;
        idToken: string;
        configId?: string;
        errorMessage?: string;
    },
    callbackError: {error:string;errorDescription:string;}
}
